import { useUserSettings } from "@services/UserSettings";
import dayjs from "dayjs";

export async function useDemoScanHistory()
{

    const today = dayjs();
    const settings = useUserSettings();

    const scanEvents = [
        { scanEventId: 'ee2426e7-2330-4f09-a54f-c22eb6a3ddde', utcDateScanned: today.subtract( 1, 'day').toISOString(), hasIssue: false },
        { scanEventId: 'ee2426e7-2330-4f09-a54f-c22eb6a3dddd', utcDateScanned: today.subtract( 2, 'day').toISOString(), hasIssue: false },
        { scanEventId: 'ee2426e7-2330-4f09-a54f-c22eb6a3dddc', utcDateScanned: today.subtract( 3, 'day').toISOString(), hasIssue: true, errorCodes: [ 'P0002' ] },
        { scanEventId: 'ee2426e7-2330-4f09-a54f-c22eb6a3dddb', utcDateScanned: today.subtract( 4, 'day').toISOString(), hasIssue: false },
        { scanEventId: 'ee2426e7-2330-4f09-a54f-c22eb6a3ddda', utcDateScanned: today.subtract( 5, 'day').toISOString(), hasIssue: false },
        { scanEventId: 'ee2426e7-2330-4f09-a54f-c22eb6a3ddd9', utcDateScanned: today.subtract( 6, 'day').toISOString(), hasIssue: false },
        { scanEventId: 'ee2426e7-2330-4f09-a54f-c22eb6a3ddd8', utcDateScanned: today.subtract( 7, 'day').toISOString(), hasIssue: false },
        { scanEventId: 'ee2426e7-2330-4f09-a54f-c22eb6a3ddd7', utcDateScanned: today.subtract( 8, 'day').toISOString(), hasIssue: false },
        { scanEventId: 'ee2426e7-2330-4f09-a54f-c22eb6a3ddd6', utcDateScanned: today.subtract( 9, 'day').toISOString(), hasIssue: false },
    ]

    if( settings.hasHealthMonitorWarning )
    {
        const errorScan = { scanEventId: 'ee2426e7-2330-4f09-a54f-c22eb6a3dddf', utcDateScanned: today.toISOString(), hasIssue: true, errorCodes: [ 'P0001', 'U0002' ] };
        scanEvents.unshift( errorScan );
    }

    return scanEvents;
}

export async function useDemoScanErrors()
{
    const errorCodes = [ 'P6472', 'U3114' ];
    return errorCodes.map( e => ({ errorCode: e }) );
}
